import { useState } from 'react';
import CMSPages from '../cms/CMSPages';
import CMSBanners from '../cms/CMSBanners';
import CMSMenus from '../cms/CMSMenus';
import CMSFooters from '../cms/CMSFooters';

export default function ContentTable() {
    const [activeTab, setActiveTab] = useState<'pages' | 'banners' | 'menus' | 'footers'>('pages');

    return (
        <div className="space-y-6">
            {/* Main Tabs */}
            <div className="flex space-x-2 border-b border-gray-200 dark:border-gray-700 pb-2 overflow-x-auto">
                {['pages', 'banners', 'menus', 'footers'].map((tab) => (
                    <button
                        key={tab}
                        onClick={() => setActiveTab(tab as any)}
                        className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors capitalize ${activeTab === tab
                            ? 'bg-brand-500 text-white'
                            : 'text-gray-500 hover:text-gray-700 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-800'
                            }`}
                    >
                        {tab}
                    </button>
                ))}
            </div>

            {/* Content Areas */}
            <div className="mt-6">
                {activeTab === 'pages' && <CMSPages />}
                {activeTab === 'banners' && <CMSBanners />}
                {activeTab === 'menus' && <CMSMenus />}
                {activeTab === 'footers' && <CMSFooters />}
            </div>
        </div>
    );
}
